export default "__VITE_PUBLIC_ASSET__cc21bb53__"